<template lang="pug">
  #CustomerTempModel.CustomerModel.CustomerModel-tempModel.overflow-hidden(
    :class="{ 'CustomerModel-active': showModel }"
  )
    .content-header.modal_header.rounded-bottom-1rem.pt-0(
      style="height: 50px;"
    )
      .row.align-items-center.h-100
        .col-10
          h5.mb-0 {{ title }}
        .col-2.d-flex.align-items-center.justify-content-center
          i.iconClose(
            @click="closeModel()"
          )
    .h-100.overflow-hidden(
      style="padding-top: 60px!important;"
    )
      .content.h-100.overflow-auto(
        style="padding-bottom: 70px;"
      )
        .cursor-default.mt-2.px-3 請美容顧問設定3-5個個人特色
        .cursor-default.mt-3.text-center(
          v-if="list.length == 0"
        ) 尚未設定專業項目
        .mb-2.mx-1.p-3.d-flex.flex-wrap.justify-content-between
          template(
            v-for="(skill, index) in list"
          )
            .product.mb-3.px-3.py-2.outline-product.border-black.custom-shadow(
              :class="{ 'selected': status(skill.skill_id) }"
              @click="addSkills(skill.skill_id, index)"
            )
              .content-product
                .input_wrap.d-flex
                  .product_info.row.w-100.h-100
                    .col
                      h6.mb-0 {{ skill.skill_name }}
      .d-flex.w-100.bg-white.position-fixed.align-items-center.justify-content-center(
        style="bottom: 1rem; height: 60px; z-index: 3;"
      )
        .col-6
          button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
            type="button",
            @click="saveHandler()",
            style="border: 4px solid #000;border-radius: 50px;padding: 0px 15px;box-shadow: 0.2rem 0.2rem 0 #00000033;",
          ) 確定

</template>

<script>
import IconCloseUrl from '@/assets/images/icon/icon_close.png';
import $ from 'jquery';

const _ = require('lodash');

export default {
  name: 'baSkillsModel',
  components: {
  },
  props: {
    list: { //技能選項
      type: [Array, Object],
      default: null
    },
    selectList: { //ba選擇的技能
      type: [Array, Object],
      default: null
    },
    title: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      showModel: false,
      skillsList: [] //ba選擇的技能 for component
    };
  },
  mounted() {
    this.$EventBus.$on('openBaSkillsModel', () => {
      this.initHandler();
    });
  },
  methods: {
    initHandler() {
      const vm = this;
        vm.skillsList = vm.selectList.map(item => item.skill_id);
        vm.openModel();
    },
    status(id) {
      const status = this.skillsList.find(item => item == id);
      if(status) {
        return true
      }else{
        return false
      }
    },
    addSkills(id, index) {
      const vm = this;
      //有沒有被選擇 
      const isSelected = this.skillsList.indexOf(id);
    if(isSelected == -1) {
      this.skillsList.push(id);
    }else{
      this.skillsList.splice(isSelected, 1);
    }
    },
    openModel() {
      this.showModel = true;
    },
    closeModel() {
      this.$emit('closeModelHandler');
      this.showModel = false;
      $('.icon-back').removeClass('d-none');
    },
    saveHandler() { //確認選擇的技能
      const vm = this;
      if(vm.skillsList.length >5) {
        vm.$swal.fire({
          icon: 'error',
          title: '超出限制，最多五則'
        });
        return;
      }
      vm.$emit('saveSkills',vm.skillsList);
      vm.closeModel();
    },
  },
  beforeDestroy() {
    this.$EventBus.$off('openBaSkillsModel');
  },
  computed: {
  },
};
</script>

<style lang="scss" scoped>
  @font-face {
      font-family: "icon";
      src: url("../../assets/fonts/icon.eot?hrpp7d");
      src: url("../../assets/fonts/icon.eot?hrpp7d#iefix") format("embedded-opentype"), url("../../assets/fonts/icon.ttf?hrpp7d") format("truetype"), url("../../assets/fonts/icon.woff?hrpp7d") format("woff"), url("../../assets/fonts/icon.svg?hrpp7d#icon") format("svg");
      font-weight: normal;
      font-style: normal;
      font-display: block;
    }

  i {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: "icon" !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 1.2rem;
    margin-bottom: 4px;
  }

  .iconClose:before {
    content: "\e908";
  }
  .border-black{
    border: 0.2rem solid #000;
  }
  .outline-product {
    display: block;
    border-radius: 1rem;
    padding: 1rem;
    cursor: pointer;
  }
  .custom-shadow {
    -webkit-box-shadow: 0.2rem 0.2rem 0 #00000033;
    box-shadow: 0.2rem 0.2rem 0 #00000033;
  }

  .product {
    flex: 0 0 48%;
  }
  .selected{
      background-color: #fe8b8b;
    }
  .product_info {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    height: 100px;
  }
  .product_info > .col {
    display: flex;
    align-items: center;
  }

  input[type="checkbox"], input[type="radio"] {
    position: absolute;
    width: 1px;
    height: 1px;
    display: none;
    opacity: 0;
  }
</style>

<style lang="scss">
  .el-radio {
    padding-top: 8px;
  }
  .el-cascader-menu {
    min-width: 40vw;
    max-width: 160px;
  }
  .el-cascader-node {
    padding-left: 10px;
  }
  .el-input__inner {
    border-radius: 20px;
    background-color: #eee;
  }
  .el-cascader-node__label {
    padding: 0;
  }
  .el-icon-circle-close {
    color: #333;
  }
  /*Fixes double tap on iOS*/
  .el-scrollbar {
    > .el-scrollbar__bar {
      opacity: 1 !important;
    }
  }
</style>
